import dayjs from "dayjs";

export const TablePageSize = 100;
export const UserTablePageSize = 20;
export const WorkforceTablePageSize = 5;
export const TechnicianManagementTablePageSize = 10;
export const TablePageSizeOptions = ["5","10", "25", "50", "100"];
export const TechnicianManagementTablePageSizeOptions =["10", "25", "50", "100"];

// dayjs will follow the timezone on your local machine
// azure is already in UTC, and the time sent will always be -8 hrs
// therefore the solution to this issue is to add +8hrs to mitigate azure UTC timing
export const NOW_UTC_OFFSET = () => {
    return dayjs().format('YYYY-MM-DDTHH:mm:ss');
}